// Quando true, oculta o <Sidebar /> lateral e renderiza o menu antigo
// (AppMenuNav do CoreUI) dentro do DefaultHeader.
// Default: false (sidebar novo, header limpo).
export const LEGACY_NAV = false
